var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 112,
    viewBox: "0 0 120 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_287_4402)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2679 95C30.9516 95 24.1346 91.0693 20.4766 84.7415L5.74444 59.2582C2.08616 52.9307 2.08616 45.0693 5.74444 38.7418L20.4769 13.2582C24.1346 6.9307 30.9519 3 38.2679 3H67.7328C75.0491 3 81.8661 6.9307 85.5241 13.2582L100.257 38.7418C103.915 45.0693 103.915 52.9307 100.257 59.2582L85.5241 84.7418C81.8664 91.0693 75.0491 95 67.7328 95H38.2679Z",
    fill: "url(#paint0_linear_287_4402)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2674 92.665C31.7837 92.665 25.7425 89.1817 22.5011 83.5744L7.76863 58.0908C4.52667 52.4835 4.52667 45.5166 7.76863 39.9093L22.5011 14.4257C25.7425 8.81836 31.784 5.33508 38.2674 5.33508H67.7323C74.2159 5.33508 80.2572 8.81836 83.4986 14.4257L98.231 39.9093C101.473 45.5166 101.473 52.4835 98.231 58.0908L83.4986 83.5744C80.2572 89.1817 74.2156 92.665 67.7323 92.665H38.2674Z",
    fill: "url(#paint1_linear_287_4402)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.256 38.7424L85.5234 13.2579C81.8666 6.92986 75.0487 3 67.7327 3H38.2678C30.9518 3 24.1339 6.92986 20.4771 13.2576L5.74434 38.7424C2.08522 45.0701 2.08522 52.9299 5.74434 59.2579L20.4768 84.7424C24.1337 91.0701 30.9515 95 38.2675 95H67.7324C75.0484 95 81.8663 91.0701 85.5232 84.7424L100.256 59.2579C103.915 52.9301 103.915 45.0704 100.256 38.7424H100.256ZM98.2312 58.0903L83.4987 83.5748C80.2582 89.1812 74.2163 92.6651 67.7327 92.6651H38.2678C31.7842 92.6651 25.7426 89.1812 22.5018 83.5748L7.76933 58.0903C4.52624 52.4838 4.52624 45.5162 7.76933 39.9099L22.5018 14.4255C25.7423 8.81904 31.7842 5.33519 38.2678 5.33519H67.7327C74.2163 5.33519 80.2579 8.81904 83.4987 14.4255L98.2312 39.9099C101.474 45.5164 101.474 52.4841 98.2312 58.0903Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2674 90.3298C32.6167 90.3298 27.3511 87.2939 24.5258 82.4065L9.79334 56.9229C6.96798 52.0358 6.96798 45.9638 9.79334 41.0763L24.5258 15.5927C27.3511 10.7056 32.6164 7.66943 38.2674 7.66943H67.7323C73.383 7.66943 78.6485 10.7053 81.4739 15.5927L96.2063 41.0763C99.0317 45.9635 99.0317 52.0355 96.2063 56.9229L81.4739 82.4065C78.6485 87.2937 73.3833 90.3298 67.7323 90.3298H38.2674Z",
    fill: "url(#paint2_linear_287_4402)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2673 87.995C33.4492 87.995 28.9597 85.4063 26.5507 81.2393L11.8183 55.7557C9.40921 51.5887 9.40921 46.4113 11.8183 42.2443L26.5507 16.7607C28.9597 12.5937 33.4492 10.005 38.2673 10.005H67.7322C72.5503 10.005 77.0398 12.5937 79.4488 16.7607L94.1813 42.2443C96.5903 46.4113 96.5903 51.5887 94.1813 55.7557L79.4488 81.2393C77.0398 85.4063 72.5503 87.995 67.7322 87.995H38.2673Z",
    fill: "url(#paint3_linear_287_4402)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1562 54.5877L88.6211 60.7007L77.4238 80.0722C75.4246 83.5303 71.7303 85.66 67.7322 85.66H38.2673C34.2691 85.66 30.5749 83.5303 28.5756 80.0722L27.8508 78.8184L24.6335 73.254L13.8432 54.5877C11.8439 51.1296 11.8439 46.8705 13.8432 43.4123L27.0487 20.5712L28.5756 17.9279C30.5749 14.4698 34.2691 12.3401 38.2673 12.3401H67.7322C71.7303 12.3401 75.4246 14.4698 77.4238 17.9279L81.4735 24.9329L92.1562 43.4123C94.1555 46.8705 94.1555 51.1296 92.1562 54.5877Z",
    fill: "url(#paint4_linear_287_4402)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.1
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1563 54.5878L88.6211 60.7008L27.0491 20.5709L28.5759 17.9277C30.5752 14.4696 34.2694 12.3398 38.2676 12.3398H67.7325C71.7307 12.3398 75.4249 14.4696 77.4241 17.9277L92.1566 43.4121C94.1558 46.8702 94.1558 51.1294 92.1566 54.5875L92.1563 54.5878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4734 24.9327L27.8511 78.8181L13.8434 54.5875C11.8442 51.1294 11.8442 46.8702 13.8434 43.4121L27.049 20.5709L28.5759 17.9277C30.5751 14.4696 34.2693 12.3398 38.2675 12.3398H67.7324C71.7306 12.3398 75.4248 14.4696 77.424 17.9277L81.4737 24.9327H81.4734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.1
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4455 12.3401C45.2886 27.3916 29.8851 61.5741 24.6335 73.254L13.8432 54.5877C11.8439 51.1296 11.8439 46.8705 13.8432 43.4123L27.0487 20.5712L28.5756 17.9279C30.5749 14.4698 34.2691 12.3401 38.2673 12.3401H52.4455Z",
    fill: "white"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3884 45.4L47.4604 43.3333L50.482 38.1666L53.5036 33L59.5467 43.3333L69.6186 45.4L61.5611 53.6667L63.5754 64L53.5036 58.8334L43.4316 64L45.4461 53.6667L37.3884 45.4Z",
    fill: "url(#paint5_linear_287_4402)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4315 43.32L53.5036 32.9601L59.5759 43.32L69.6961 45.392L61.5999 53.68L63.624 64.0399L53.5036 58.86L43.3833 64.0399L45.4073 53.68L37.3111 45.392L47.4315 43.32ZM42.2194 54.6407L35.2106 47.4661C34.4545 46.692 34.1801 45.564 34.4957 44.5264C34.8112 43.4888 35.6662 42.7081 36.7237 42.4915L45.5601 40.6824L50.9672 31.4573C51.4965 30.5542 52.4612 30 53.5036 30C54.5462 30 55.5109 30.5542 56.04 31.4573L61.4472 40.6824L70.2837 42.4915C71.3412 42.7081 72.196 43.4888 72.5116 44.5264C72.8271 45.564 72.5528 46.692 71.7966 47.4661L64.788 54.6407L66.5129 63.4695C66.73 64.5808 66.2973 65.7192 65.3985 66.4018C64.4996 67.0845 63.2922 67.1917 62.2883 66.6778L53.5036 62.1815L44.7189 66.6778C43.7151 67.1917 42.5076 67.0845 41.6088 66.4018C40.7098 65.7192 40.2773 64.5808 40.4944 63.4695L42.2194 54.6407Z",
    fill: "url(#paint6_linear_287_4402)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_287_4402",
    x: 0,
    y: 0,
    width: 120,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_287_4402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_287_4402",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_4402",
    x1: 10.723,
    y1: 20.6612,
    x2: 95.2383,
    y2: 77.4628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1CAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_287_4402",
    x1: 12.8259,
    y1: 22.0709,
    x2: 93.1365,
    y2: 76.0466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1CAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_287_4402",
    x1: 14.929,
    y1: 23.4807,
    x2: 91.0351,
    y2: 74.6305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_287_4402",
    x1: 17.0323,
    y1: 24.8906,
    x2: 88.9337,
    y2: 73.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_287_4402",
    x1: 19.1353,
    y1: 26.3003,
    x2: 86.8326,
    y2: 71.7989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1CAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_287_4402",
    x1: 34.8704,
    y1: 35,
    x2: 72.4286,
    y2: 65.2627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_287_4402",
    x1: 36.8849,
    y1: 33.5,
    x2: 72.4064,
    y2: 66.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E9E9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge1);
export default __webpack_public_path__ + "static/media/badge-1.8e1ed9d3bffbad8934d062b04999a4d6.svg";
export { ForwardRef as ReactComponent };